<template>
  <div class="header">
    <div class="hearder-logo">
      <img
          :src="require('@/assets/' + globalPath + '/logo.png')"
          class="logo"
          height="58"
          alt=""
        >
      <h1>{{processEnv.VUE_APP_TITLE}}</h1>
      
    </div>
    <div class="hearder-userinfo">
      <div class="entry">
        <span class="username">
          帐号：{{userName}}
        </span>
        <span class="logout" @click.prevent="golost"
        >
          修改密码
        </span>
        <span class="logout" @click="logOut">退出</span>
      </div>
    </div>

    <forget-password ref="forgetPassword"></forget-password>
    <modify-password ref="modifyPassword"></modify-password>
  </div>
</template>

<script>
import { loginOut } from '@/api/login.js'
import forgetPassword from '@/components/forgetPassword.vue'
import modifyPassword from '@/components/modifyPassword.vue'
import { removeStore, removeStoreSession, getStoreSession, getStore } from '@/utils/utils.js'
export default {
  components: {
      forgetPassword,
      modifyPassword,
  },
  data() {
    return {
      userName: '',
      globalPath: '',
      processEnv: process.env,
    }
  },
  created(){
    this.globalPath = process.env.VUE_APP_LOGO_PATH
  },
  methods: {
    golost() {
        this.$refs.modifyPassword.modifyVisible =  true
    },
    logOut() {
      loginOut().then((res) => {
        console.log('退出成功')
        removeStore('authToken');
        removeStore('refreshToken');
        removeStore('loginInfo');
        removeStore('loginInfouser');
        removeStore('loginUser');
        removeStoreSession('haslogin');
        this.$router.push({ path: '/login' });
      }, (err) => {
      })
    },
  },
  mounted() {
    if (getStoreSession('haslogin') == 'yes') {
      this.flag = true
      let loginInfo = JSON.parse(getStore('loginInfo'));
      let loginInfouser = JSON.parse(getStore('loginInfouser'));
      this.userName = loginInfo.userInfo.userName||loginInfouser.userInfo.userName
    }
  }
}
</script>
<style lang="scss">
.el-dropdown-menu {
  .el-dropdown-menu__item {
    text-align: center;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(67, 146, 127, 0.11);
  .hearder-logo {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 80px;
    .logo {
      margin-left: 30px;
    }
    h1 {
      margin-left: 16px;
      font-size: 20px;
      color: #222222;
    }
  }
  .hearder-userinfo {
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: #333333;
    .entry {
      margin-right: 0;
    }
    .modifyPass{
      cursor: pointer;
    }
    .username {
      font-size: 16px;
      color: #999;
      margin-right: 22px;
      img {
        margin-top: -3px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .logout {
      margin-left: 10px;
      cursor: pointer;
      color: #999;
    }
    .el-button--text {
      font-size: 16px;
      color: #333333;
    }
    .loginout {
      margin-left: 32px;
    }
    .split {
      width: 1px;
      height: 16px;
      margin: 0 20px;
      background-color: #999999;
      display: inline-block;
    }
  }
}
.login {
      a {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin: 0 20px;
        display: inline-block;
        text-align: center;
      }
    }
</style>
